"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityMandateDetailsContactMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_mandate_details_entry_entity_1 = require("./opportunity-mandate-details-entry.entity");
const contact_entity_1 = require("./contact.entity");
let OpportunityMandateDetailsContactMap = class OpportunityMandateDetailsContactMap {
    constructor(mandateId, contactId) {
        this.mandateId = mandateId;
        this.contactId = contactId;
    }
};
exports.OpportunityMandateDetailsContactMap = OpportunityMandateDetailsContactMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsContactMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mandate_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsContactMap.prototype, "mandateId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsContactMap.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_mandate_details_entry_entity_1.OpportunityMandateDetailsEntry, (mandate) => mandate.mandateDetailsContacts, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "mandate_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _a : Object)
], OpportunityMandateDetailsContactMap.prototype, "mandate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _b : Object)
], OpportunityMandateDetailsContactMap.prototype, "contact", void 0);
exports.OpportunityMandateDetailsContactMap = OpportunityMandateDetailsContactMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_mandate_details_contact_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number])
], OpportunityMandateDetailsContactMap);
